import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.unregister();

reportWebVitals();



// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';

// import axios from 'axios';

// import keycloak from './lib/keycloak';

// keycloak
//   .init({
//     onLoad: "login-required",
//     checkLoginIframe: false,
//   })
//   .then((authenticated: boolean) => {

//     console.log("Authenticated:", authenticated);
//     console.log("Keycloak Token:", keycloak.token);

//     // Store keycloak token
//     localStorage.setItem("kc_token", keycloak.token || "");
//     localStorage.setItem("loginType", "keycloak");
//     // Call Java backend login API
//     axios.post(
//       `${process.env.REACT_APP_ICPANEL_URL}auth/keycloak-login`,
//       {
//         keycloakToken: keycloak.token
//       }
//     )
//     .then((res) => {

//       console.log("Backend Login Response:", res.data);

//       // Store app token
//       localStorage.setItem("token", res.data.token);

//       // Store role
//       localStorage.setItem("UserRole", res.data.UserRole);

//       // Store employee details
//       localStorage.setItem("empCode", res.data.empCode);
//       localStorage.setItem("EmpName", res.data.EmpName);
//       localStorage.setItem("SignupEmpId", res.data.SignupEmpId);
      

//       // Load app
//       ReactDOM.render(
//         <React.StrictMode>
//           <App />
//         </React.StrictMode>,
//         document.getElementById('root')
//       );

//     })
//     .catch((err) => {
//       console.error("Backend login failed", err);
//     });

//   })
//   .catch((err: any) => {
//     console.error("Keycloak init failed", err);
//   });